import { useQuery } from '@tanstack/react-query';
import { fiscalYearsApi, FiscalYearDto } from '../api/fiscalYears';

export const useFiscalYears = () => {
  return useQuery<FiscalYearDto[]>({
    queryKey: ['fiscalYears'],
    queryFn: () => fiscalYearsApi.list(),
  });
};
